<template>
  <v-app column v-if="this.widgetData.loading">
    <div class="text-xs-center">
      <v-progress-circular indeterminate color="primary" />
    </div>
  </v-app>
  <v-app v-else>
    <v-content>
      <v-container class="main-container">
        <the-alert-bar
          :message="alert.message" :type="alert.type" :dismiss-alert-cb="clearErrorMessage" />
        <div style="position: relative;">
          <v-img v-if="isEnhancedRefundProgram && widgetData.logo" :src="widgetData.logo"
                contain position="center center" width="100%" height="100" />
           <v-img v-if="logoUrl" class="centered-image" contain position="center center"
           width="100%" height="100" :src="logoUrl ?? ''" />
        </div>
        <v-slide-x-reverse-transition mode="out-in">
          <router-view class="animated" />
        </v-slide-x-reverse-transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TheAlertBar from 'components/TheAlertBar.vue';
import urlUtils from 'utils/url';
import { getProductSlug } from 'utils/product';
import fanshieldLogo from './assets/logos/fanshield.png';
import regshieldLogo from './assets/logos/regshield.png';
import tourshieldLogo from './assets/logos/tourshield.png';
import stayshieldLogo from './assets/logos/stayshield.png';
import athleteshieldLogo from './assets/logos/athleteshield.png';

export default {
  name: 'App',
  components: {
    TheAlertBar,
  },
  computed: {
    ...mapGetters('widgetData', ['widgetData']),
    ...mapGetters(['alert']),
    logoUrl: () => {
      const product = urlUtils.getIsAthleteShield() ? 'athleteshield' : urlUtils.getProductFromDomain();
      switch (product) {
        case 'fanshield':
          return fanshieldLogo;
        case 'regshield':
          return regshieldLogo;
        case 'tourshield':
          return tourshieldLogo;
        case 'stayshield':
          return stayshieldLogo;
        case 'athleteshield':
          return athleteshieldLogo;
        default:
          return null;
      }
    },
    isEnhancedRefundProgram: () => urlUtils.getProductFromDomain() === 'enhancedrefundprogram',
  },
  methods: {
    ...mapActions(['pushMessageAlert', 'setUrlParams']),
    ...mapActions('ipStatus', ['fetchIpStatus']),
    ...mapActions('widgetData', ['fetchICWWidgetData']),
    clearErrorMessage() {
      this.pushMessageAlert({
        message: '',
        type: '',
      });
    },
  },
  watch: {
    ipStatus(data) {
      if (data) {
        this.fetchICWWidgetData({
          client: this.client,
          params: {
            product: getProductSlug(urlUtils.getProductFromDomain()),
            country: this.ipStatus.country_code,
            region: this.ipStatus.region_code,
          },
        }).catch(() => {
          this.$router.push({ name: 'error' });
        });
      }
    },
  },
  created() {
    this.fetchIpStatus().catch(() => {
      this.$router.push({ name: 'error' });
    });
    this.setUrlParams(Object.fromEntries(new URLSearchParams(window.location.search)));
  },
};
</script>

<style>
.hover {
  cursor: pointer
}

html {
  scroll-behavior: smooth;
}

#app {
  background: white;
}

.v-input__control,
.v-input__control .v-label {
  font-size: 14px;
}

.divider {
  max-width: 96%;
  margin: 0 auto;
}

.rounded {
  border-radius: .25rem;
}

.goog-te-combo {
  border-style: solid;
  -webkit-appearance: menulist;
  appearance: menulist;
  box-sizing: border-box;
  align-items: center;
  white-space: pre;
  -webkit-rtl-ordering: logical;
  cursor: default;
}

.v-tooltip__content {
  background-color: rgb(0, 0, 0) !important;
  width: 640px;
}

.main-container {
  padding: 40px;
  width: 1281px;
  height: auto;
  background-color: #ffffff;
  margin: 0 auto;
  position: relative;
}

@font-face {
  font-family: 'Gotham';
  src: url('./assets/fonts/Gotham/GothamMedium.otf');
}

/* Tablet Break Point */
@media screen and (max-width: 1264px) {
  .main-container {
    width: 768px;
    padding: 20px;
  }
}


/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .main-container {
    width: 321px;
    padding: 10px;
  }

  .v-select__selection--comma {
    margin-left: 0px !important;
  }

  .v-tooltip__content {
    width: auto;
  }
}

/* Mobile Break Point Larger */
@media screen and (min-width: 375px) and (max-width: 767px) {
  .main-container {
    width: 100%;
    padding: 10px;
    margin: 0;
  }
}

.centered-image {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5vh;
}

</style>
